module.exports = __webpack_public_path__ + "img/background.e7ea57c8.png";